// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n@page {\n  margin: 20mm;\n}\n@media print {\n}\n", ""]);
// Exports
module.exports = exports;
